export default "__VITE_ASSET__osc4AJeV__"